(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n/tr", [], factory);
	else if(typeof exports === 'object')
		exports["i18n/tr"] = factory();
	else
		root["i18n/tr"] = factory();
})(window, function() {
return 